import { useState } from "react";
import { useGameStore } from "../store/gameStore.js";

export function StartScreen() {
  const startMatch = useGameStore((s) => s.startMatch);
  const [anteEnabled, setAnteEnabled] = useState(true);

  return (
    <div className="screen start-screen">
      <img className="app-logo" src="./logo.png" alt="JOKER Hold'em ロゴ" />
      <h1 className="app-title">JOKER Hold'em</h1>
      <p className="app-subtitle">フロップ1枚が常にジョーカーの特殊NLH。ヘッズアップでbotと対戦。</p>

      <section className="rules-box">
        <h2 className="rules-title">ルール(通常のNLHとの違い)</h2>
        <ul className="rules-list">
          <li>フロップ3枚のうち1枚は常に<strong>ジョーカー</strong></li>
          <li>ジョーカーは「自分の2枚」と「場に見えている実カード」<strong>以外の好きなカード</strong>として使える</li>
          <li>解釈は<strong>プレイヤーごとに独立</strong> — 同じジョーカーを、あなたと相手が別々のカードに見立ててよい</li>
          <li>それ以外は通常のノーリミット・ホールデムと同じ</li>
        </ul>
      </section>

      <div className="start-settings">
        <label className="ante-toggle">
          <input
            type="checkbox"
            checked={anteEnabled}
            onChange={(e) => setAnteEnabled(e.target.checked)}
          />
          アンティあり(各0.5bb)
        </label>
        <p className="settings-note">50bbスタート・ヘッズアップ対bot。設定はマッチ開始後は変更できません。</p>
      </div>

      <button type="button" className="primary-btn" onClick={() => startMatch(anteEnabled)}>
        マッチ開始
      </button>

      <button type="button" className="secondary-btn" onClick={() => useGameStore.getState().goHistory()}>
        ハンド履歴を見る
      </button>
    </div>
  );
}
